var React = require('react');

function PriceTag (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(5 5)","fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"currentColor","fillRule":"nonzero","cx":"10.252","cy":"4.25","r":"1","key":0}),React.createElement("path",{"d":"M7.252 0h7.25v7.25l-6.697 6.67a2 2 0 0 1-2.87-.047L.542 9.19a2 2 0 0 1 .072-2.81L7.252 0z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

PriceTag.defaultProps = {"width":"24","height":"24"};

module.exports = PriceTag;

PriceTag.default = PriceTag;
